// extracted by mini-css-extract-plugin
export default {"title":"AddGuestsComponent_title__eN5ST","iconEdit":"AddGuestsComponent_iconEdit__axvju","subTitle":"AddGuestsComponent_subTitle__fufOJ"};